import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/api";
import { Navigate } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export default function Login() {
  const { login, user, loading } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  if (!loading && user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      // Trim invisible whitespace/newlines that iOS Safari autofill injects
      await login(username.trim(), password.trim());
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Falha ao autenticar");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen login-bg flex items-center justify-center px-6 relative overflow-hidden">
      {/* corner marks */}
      <div className="absolute top-6 left-6 flex items-center gap-2">
        <span className="brand-dot" />
        <span className="label-eyebrow">Acesso</span>
      </div>
      <div className="absolute bottom-6 right-6 label-eyebrow opacity-50">Pesquisa Customizável</div>

      <div className="w-full max-w-md fade-up">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="" className="w-24 h-24 object-contain mb-6" data-testid="login-logo" />
          <h1 className="text-3xl font-light tracking-tight" style={{ color: "var(--text-primary)" }}>
            Pesquisa Customizável
          </h1>
        </div>

        <form
          onSubmit={onSubmit}
          className="surface p-8 fade-up delay-1"
          data-testid="login-form"
        >
          <div className="mb-5">
            <label className="label-eyebrow block mb-2">Usuário</label>
            <input
              data-testid="login-username"
              className="input-base"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="vip"
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              inputMode="text"
              required
            />
          </div>

          <div className="mb-6">
            <label className="label-eyebrow block mb-2">Senha</label>
            <input
              data-testid="login-password"
              type="password"
              className="input-base"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              required
            />
          </div>

          {error && (
            <div
              data-testid="login-error"
              className="mb-4 px-3 py-2 text-sm border"
              style={{ borderColor: "var(--danger)", color: "var(--danger)", background: "rgba(244,63,94,0.06)" }}
            >
              {error}
            </div>
          )}

          <button
            data-testid="login-submit"
            type="submit"
            disabled={submitting}
            className="btn-gold w-full py-3 text-sm tracking-wider uppercase rounded-sm flex items-center justify-center gap-2"
          >
            {submitting ? "Autenticando…" : (<>Entrar <ArrowRight size={16} weight="bold" /></>)}
          </button>
        </form>
      </div>
    </div>
  );
}
